<template>
    <div class="card"  style="height: 100%">
        <div class="card-header d-flex justify-content-between">
            <div class="">Open street Map</div>
            <a v-on:click="commentBox(vue)" class="txt-color-white right-padding-50">
                <i class="fa fa-lg fa-comments"></i>
            </a>
            </div>
            <div class="card-body">
             <div id="mapContainer" style="width: 100%">
             <l-map :center="center" :zoom="4.6" ref="mymap">
             <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
             <l-geo-json
                  v-if="show"
                  :geojson="geojson"
                  :options="options"
                  :options-style="styleFunction">

             </l-geo-json>

             <div
               v-for="(feature) in revjson.features"
               :key="'circle' + feature.properties.state_lower">
                <l-circle
                  v-if="feature.properties.lat!= null"
                  :lat-lng="getLatLong(feature.properties.lat, feature.properties.long)"
                  :fillColor="circle.fillColor"
                  :color="circle.color"
                  :fillOpacity="circle.fillOpacity"
                :draggable="true"
                :radius="Math.round(feature.properties.cost/25)">
               </l-circle>
                         <l-circle
                             v-if="feature.properties.lat!= null"
                             :lat-lng="getLatLong(feature.properties.lat, feature.properties.long)"
                             :fillColor="circle2.fillColor"
                             :color="circle2.color"
                             :fillOpacity="circle2.fillOpacity"
                             :draggable="true"
                             :radius="Math.round(feature.properties.revenue/20)">
                           <l-popup>
                            <b>City: </b>{{feature.properties.city}}<br/><br/>
                            <b>State: </b>{{feature.properties.state_lower}}<br/><br/>
                            <b>Cost: </b>{{feature.properties.cost}}<br/><br/>
                             <b>Revenue: </b>{{feature.properties.revenue}}<br/><br/>
                           </l-popup>
                          </l-circle>
                       </div>
                   <l-control
                         v-if= "legend.display"
                         :position="legend.position">
                         <div class="info legend">
                         <div v-for="(index) in grades.length"  :key =" 'maplegend'+grades[index]">
                          <div v-if="grades[index] !=null"> <i v-bind:style="{ 'background': getColor(grades[index] + 1)}"></i>{{grades[index]}}
                          </div>
                          </div>
                          </div>
                   </l-control>
                  </l-map>

             </div>
            </div>

     </div>

</template>
<script>
// import * as Vue2Leaflet from 'vue2-leaflet';
import L from 'leaflet';
import {LCircle, LControl, LGeoJson, LMap, LPopup, LTileLayer} from 'vue2-leaflet';

import axios from 'axios';
import "leaflet/dist/leaflet.css";
// console.log(Vue2Leaflet)



   export default {
           name: "Map",
           components: {
               "l-map": LMap,
               "l-tile-layer": LTileLayer,
               "l-circle":LCircle,
               "l-geo-json": LGeoJson,
               "l-popup":LPopup,

               "l-control":LControl
           },
           data() {
               return {
                   mymap: null,
                   loading: false,
                   // latlng: [],
                   showModal: false,
                   cmnt: "",
                   annotations: [],
                   annotationTitle: '',
                   geojson:null,
                   revjson:null,
                   show: true,
                   enableTooltip: true,
                   legend:
                   {
                    position:'bottomright',
                    display:true,
                   },
                   grades : [0, 500000, 1000000, 1500000, 2000000, 2500000, 3000000, 3500000],
                   circle: {
                       fillColor:"#e65339",
                       color:"#e65339",
                       fillOpacity:3.0
                    },
                   circle2: {
                       fillColor:"#2897bf",
                        color:"#2897bf",
                        fillOpacity:0.3
                   },
                   center: L.latLng(22.5937, 80.9629),
                   url:"https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibXVpbnNoYXJpZmYiLCJhIjoiY2tmMTlsbnRzMTI2ZTJzcGhiemt6d2Z2MiJ9.-apvKqeNTsJ5jJ7Sm1MkTg",
                   attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',

               };
           },
            computed: {
               options() {
                 return {
                   onEachFeature: this.onEachFeatureFunction
                 };
               },
               styleFunction() {
                 const fillColor = this.fillColor; // important! need touch fillColor in computed for re-calculate when change fillColor
                 console.log(fillColor)
                 return (feature) => {
                   return {
                      fillColor: this.getColor(feature.properties.revenue_by_state),
                      fillOpacity: 0.9,
                      weight: 2,
                      opacity: 1,
                      color: 'black',
                   };
                 };
               },
               onEachFeatureFunction() {
                 if (!this.enableTooltip) {
                   return () => {};
                 }
                 return (feature, layer) => {
                   layer.bindTooltip(
                     "<div>StateName: " +
                       feature.properties.state_name +
                       "</div><div>Revenue: " +
                       feature.properties.revenue_by_state +
                       "</div>",
                     { permanent: false, sticky: true }
                   );
                 };
               }
             },
             methods: {
               getLatLong(lat, long) {
                    // eslint-disable-next-line
                    return L.latLng(lat, long)
                  },
              getColor :function(d) {
                 return d > 3500000 ? '#00441b' :
                        d > 3000000  ? '#006d2c' :
                        d > 2500000  ? ' #238b45' :
                        d > 2000000  ? '#41ae76' :
                        d > 1500000   ? ' #66c2a4' :
                        d > 1000000   ? ' #99d8c9' :
                        d > 500000   ? '#ccece6' :
                                   ' #e5f5f9';
             }
             },
             mounted() {
             this.loading = true;
             axios.all([
                      axios({ url: '/json/OSM.json', baseURL: '', method: 'GET' }),
                       axios({ url: '/json/osmmapmetrics.json', baseURL: '', method: 'GET' })
                     ]).then(axios.spread((r0, r1) => {

                       //Assigning to the variables from axios output
                        this.geojson=r0.data
                        this.revjson=r1.data;

            console.log("Geo Json 1",this.geojson);
            console.log("Geo Json 2",this.revjson);
             this.loading = false;
              })).catch(error => console.error(error));
              }
           };
</script>
 <style scoped>
     #mapContainer {
         width: 500px;
         height: 800px;
     }
     .legend {
         line-height: 10px;
         color: #555;
     }
     .legend i {
         width: 100px;
         height: 15px;
         float: left;
         margin-right: 17px;
         opacity: 0.7;
     }
     .info {
         padding: 6px 8px;
         font: 14px/16px Arial, Helvetica, sans-serif;
         background: white;
         background: rgba(255,255,255,0.8);
         box-shadow: 0 0 15px rgba(0,0,0,0.2);
         border-radius: 5px;
     }
 </style>